import * as Sentry from '@sentry/react';
import { createBrowserRouter } from 'react-router-dom';
import appRoutes from './Routes';

// Wrapping the router with `wrapCreateBrowserRouterV6` lets Sentry
// capture React render-phase errors thrown inside route components —
// these were previously swallowed by React Router's default
// `RenderErrorBoundary` and never reached Sentry (see ECDEX-2092).
//
// We use the version-suffixed `wrapCreateBrowserRouterV6` rather than
// the un-suffixed alias because the latter is deprecated in @sentry/react
// v8 and removed in v9, and the v6-specific wrapper is the one that
// pairs with `reactRouterV6BrowserTracingIntegration`.
//
// Exported as a factory rather than a module-level instance so the wrapper
// runs *after* `initializeSentry()` in `src/index.tsx`. If we evaluated it
// at import time, ES module evaluation order would invoke
// `wrapCreateBrowserRouterV6` before `Sentry.init()`, leaving the React
// Router v6 tracing integration unable to attach matched route patterns
// to error events.
const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouterV6(createBrowserRouter);

const createClientRoutes = () => sentryCreateBrowserRouter(appRoutes);

export default createClientRoutes;
